import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { API, useAuth } from "@/auth";

export default function DailyCypherCard() {
 const { user } = useAuth();
 const nav = useNavigate();
 const [data, setData] = useState(null);
 const [busy, setBusy] = useState(false);
 const [err, setErr] = useState("");

 useEffect(() => {
 if (!user) return;
 axios.get(`${API}/daily-cypher`).then(r => setData(r.data)).catch(() => {});
 }, [user]);

 if (!user || !data) return null;
 const { opponent, arena, claimed, battle_id } = data;

 const claim = async () => {
 setBusy(true); setErr("");
 try {
 const { data: battle } = await axios.post(`${API}/daily-cypher/claim`);
 nav(`/battles/${battle.id}`);
 } catch (e) { setErr(e.response?.data?.detail || "Couldn't start daily cypher"); }
 finally { setBusy(false); }
 };

 return (
 <div className="relative overflow-hidden bg-yt-surface border-2 border-yt-yellow shadow-brutal mb-8">
 <div className="absolute inset-0 opacity-40">
 <img src={arena.image} alt={arena.name} className="w-full h-full object-cover" />
 <div className="absolute inset-0 bg-gradient-to-r from-yt-bg via-yt-bg/70 to-transparent" />
 </div>
 <div className="relative grid grid-cols-1 md:grid-cols-3 items-center gap-6 p-6 md:p-8">
 <div>
 <div className="inline-block bg-yt-yellow text-black font-mono text-[10px] tracking-[0.3em] px-2 py-1 mb-3"> DAILY CYPHER · FREE</div>
 <div className="font-display text-3xl md:text-4xl tracking-tight mb-2">TODAY'S CHALLENGE</div>
 <div className="font-mono text-xs text-yt-muted">{new Date(data.date).toDateString().toUpperCase()}</div>
 <div className="font-mono text-xs text-yt-yellow mt-2">+10 PTS · WIN · NO CREDIT</div>
 </div>
 <div className="flex items-center justify-center gap-4">
 <div className="text-center">
 <div className="w-20 h-20 mx-auto bg-black border border-yt-border overflow-hidden">
 {opponent.portrait ? <img src={opponent.portrait} alt={opponent.name} className="w-full h-full object-cover" /> :
 <div className="text-4xl w-full h-full flex items-center justify-center bg-yt-surface font-display text-yt-yellow">{(opponent.name || "??").slice(0, 2).toUpperCase()}</div>}
 </div>
 <div className="font-display text-lg mt-1 leading-tight">{opponent.name}</div>
 <div className="font-mono text-[9px] text-yt-muted">{opponent.style?.toUpperCase()}</div>
 </div>
 <div className="font-display text-3xl text-yt-red">VS</div>
 <div className="text-center">
 <div className="w-20 h-20 mx-auto bg-black border border-yt-border overflow-hidden">
 <img src={arena.image} alt={arena.name} className="w-full h-full object-cover" />
 </div>
 <div className="font-display text-lg mt-1 leading-tight">{arena.name}</div>
 <div className="font-mono text-[9px] text-yt-muted">ARENA</div>
 </div>
 </div>
 <div className="text-right">
 {claimed && battle_id ? (
 <Link to={`/battles/${battle_id}`} data-testid="daily-resume" className="inline-block bg-yt-judge text-black font-display text-lg tracking-wider px-6 py-3 shadow-brutal">
 ▶ RESUME CYPHER
 </Link>
 ) : (
 <button data-testid="daily-claim" disabled={busy} onClick={claim}
 className="bg-yt-red text-white font-display text-xl tracking-wider px-6 py-3 hover:bg-yt-yellow hover:text-black shadow-brutal shadow-brutal-hover disabled:opacity-50">
 {busy ? "ENTERING..." : "▶ CLAIM CYPHER"}
 </button>
 )}
 {err && <div className="font-mono text-xs text-yt-red mt-2">{err}</div>}
 </div>
 </div>
 </div>
 );
}
